import React from 'react';
import { PaginationArrow as PaginationArrowNew } from './PaginationArrow';
import { convertOldPaginationArrowProps } from './converter.old';
import type { OldPaginationArrowProps } from './converter.old';

export type PaginationArrowProps = OldPaginationArrowProps;

export const PaginationArrow: React.FC<PaginationArrowProps> = (props) => (
  <PaginationArrowNew {...convertOldPaginationArrowProps(props)} />
);
